const searchSeoSuburbQuery = require('./searchSeoSuburb');
const searchSeoListQuery = require('./searchSeoList');
const searchProfileQuery = require('./searchProfile');
const searchProfileReviewsQuery = require('./searchProfileReviews');
const searchSeoStateQuery = require('./searchSeoState');
const searchSuggestSitemapSuburbsQuery = require('./searchSuggestSitemapSuburbs');
const searchSuggestSuburbsQuery = require('./searchSuggestSuburbs');
const searchSeoRegionQuery = require('./searchSeoRegion');
const searchSeoCategoryQuery = require('./searchSeoCategory');
const searchSuggestSitemapCategoriesQuery = require('./searchSuggestSitemapCategories');
const searchSeoHomeQuery = require('./searchSeoHome');

module.exports = {
  searchSeoSuburbQuery,
  searchSeoListQuery,
  searchProfileQuery,
  searchProfileReviewsQuery,
  searchSeoStateQuery,
  searchSuggestSitemapSuburbsQuery,
  searchSuggestSuburbsQuery,
  searchSeoRegionQuery,
  searchSeoCategoryQuery,
  searchSuggestSitemapCategoriesQuery,
  searchSeoHomeQuery,
};
